// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"AddNewGoalPop_AddNewGoalPop__u7y+p","modalBody":"AddNewGoalPop_modalBody__Ezk8i","formControl":"AddNewGoalPop_formControl__ZIS0e","add":"AddNewGoalPop_add__t3oKW"};